export const WHATSAPP_LINK = "https://wa.me/6287819091921";
